/** Espelho dos ViewModels de `DTOs/NewsDtos.cs` — Opera/Data News. */

/** Editoria do comunicado. Rótulo (filtro + cor), nunca permissão — o canal é único. */
export enum NewsCategory {
  Novidades = 1,
  Comunicado = 2,
  Pessoas = 3,
  Operacao = 4,
}

export interface NewsFeedItem {
  id: number;
  title: string;
  summary: string | null;
  body: string;
  category: NewsCategory;
  pinned: boolean;
  publishedAt: string | null;
  createdByName: string | null;
  read: boolean;
}

export interface NewsPost {
  id: number;
  title: string;
  summary: string | null;
  body: string;
  category: NewsCategory;
  pinned: boolean;
  publishedAt: string | null;
  expiresAt: string | null;
  createdByName: string | null;
  dtCreated: string;
  updatedAt: string | null;
  readCount: number;
}

export interface NewsPostRequest {
  title: string;
  summary?: string | null;
  body: string;
  category: NewsCategory;
  pinned: boolean;
  /** Publicar é estado do post, não endpoint (design D7). */
  publish: boolean;
  /** Data futura agenda a publicação. */
  publishAt?: string | null;
  expiresAt?: string | null;
}
